import { ProblemDetail } from '@valuecase/common'
import { AxiosError, AxiosResponse } from 'axios'

type ProblemDetailsError = AxiosError<ProblemDetail> & {
  response: AxiosResponse<ProblemDetail>
}

export function isProblemDetailsErrorResponse(error: unknown): error is ProblemDetailsError {
  if (!(error instanceof AxiosError)) {
    return false
  }
  if (!error.response?.data || typeof error.response.data !== 'object') {
    return false
  }
  const { status, type, title } = error.response.data
  return typeof status === 'number' && typeof type === 'string' && typeof title === 'string'
}
